import React, { useState, Fragment } from "react"
import classnames from "classnames"
import Avatar from "@components/avatar"
import { useForm } from "react-hook-form"
import { toast, Slide } from "react-toastify"
import { useHistory } from "react-router-dom"
import InputPasswordToggle from "@components/input-password-toggle"
import { HelpCircle, Coffee } from "react-feather"
import {
	Alert,
	Spinner,
	Form,
	Input,
	FormGroup,
	Label,
	Button,
	UncontrolledTooltip,
	Card,
	CardHeader,
	CardBody,
	CardSubtitle,
} from "reactstrap"

import "@styles/base/pages/page-auth.scss"
import { ContentWrapper } from "../../components"
import { postAuth } from "../../api"

const Login = () => {
	const history = useHistory()
	const [email, setEmail] = useState("")
	const [password, setPassword] = useState("")
	const [isLoading, setIsLoading] = useState(false)

	const { register, errors, handleSubmit } = useForm()

	if (localStorage.getItem("token")) history.push("/")

	const onSubmit = (data) => {
		if (data.email?.length > 0 && data.password?.length > 0) {
			setIsLoading(true)
			postAuth(data)
				.then((res) => {
					setIsLoading(false)
					if (res.error || res.offline) return
					if (
						!res.user?.role?.find(
							(role) => role === "delegate" || role === "operative"
						)
					) {
						toast.error(
							"Ovaj korisnik nema pristup Zapisničarskoj Aplikaciji"
						)
						return
					}
					toast.success(`Dobrodošao ${res.user?.name ?? ""}`)
					localStorage.setItem("token", res.token)
					history.push("/")
				})
				.catch((err) => {
					console.log(err)
					setIsLoading(false)
				})
		}
	}
	if (isLoading) {
		return (
			<div
				style={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
				}}
			>
				<Spinner />
			</div>
		)
	}
	return (
		<ContentWrapper logout={false}>
			<Card style={{ maxWidth: 520, margin: "auto" }}>
				<CardHeader>
					<h1>Zapisničarska Aplikacija</h1>
				</CardHeader>
				<CardBody>
					<CardSubtitle className="mb-2">
						Utipkajte vaše podatke ispod kako bi mogli pristupiti
						zapisničarskoj aplikaciji.
					</CardSubtitle>
					{/* <Alert color="primary">
						<div className="alert-body font-small-2">
							<p>
								<small className="mr-50">
									<span className="font-weight-bold">Admin: </span>
									bebabit8@bebabit.com
								</small>
							</p>
							<p>
								<small className="mr-50">
									<span className="font-weight-bold">
										Password:{" "}
									</span>
									000000
								</small>
							</p>
						</div>
						<HelpCircle
							id="login-tip"
							className="position-absolute"
							size={18}
							style={{ top: "10px", right: "10px" }}
						/>
						<UncontrolledTooltip target="login-tip" placement="left">
							This is just for ACL demo purpose.
						</UncontrolledTooltip>
					</Alert> */}
					<Form
						className="auth-login-form mt-2"
						onSubmit={handleSubmit(onSubmit)}
					>
						<FormGroup>
							<Label className="form-label" for="email">
								Email
							</Label>
							<Input
								autoFocus
								type="email"
								value={email}
								id="email"
								name="email"
								placeholder="john@example.com"
								onChange={(e) => setEmail(e.target.value)}
								className={classnames({
									"is-invalid": errors["email"],
								})}
								innerRef={register({
									required: true,
									validate: (value) => value !== "",
								})}
							/>
						</FormGroup>
						<FormGroup>
							<div className="d-flex justify-content-between">
								<Label className="form-label" for="password">
									Password
								</Label>
							</div>
							<InputPasswordToggle
								value={password}
								id="password"
								name="password"
								onChange={(e) => setPassword(e.target.value)}
								className={classnames({
									"is-invalid": errors["password"],
								})}
								innerRef={register({
									required: true,
									validate: (value) => value !== "",
								})}
							/>
						</FormGroup>
						<Button.Ripple type="submit" color="primary" block>
							Sign in
						</Button.Ripple>
					</Form>
				</CardBody>
			</Card>
		</ContentWrapper>
	)
}

export default Login
